import { Box, Tooltip } from "@mui/material";
import { ChevronDown } from 'lucide-react';
import { useTheme } from "@mui/material";

// Fix zero-width orange ranges (fallback)
function fixRange(minStr, maxStr) {
  const min = Number(minStr);
  const max = Number(maxStr);

  if (min === max) {
    // no orange zone → create a tiny boundary zone
    return { min, max: min + 0.0001 };
  }
  return { min, max };
}

export default function ReferenceGauge({ value, reference,arrowColor }) {

const theme = useTheme();

  // Extract reference ranges
  const lo = fixRange(reference.lower_orange_min, reference.lower_orange_max);
  const green = {
    min: Number(reference.lower_green),
    max: Number(reference.upper_green)
  };
  const ho = fixRange(reference.upper_orange_min, reference.upper_orange_max);

  // Gauge normalization base
  const min = lo.min;                         // start of gauge
  const max = ho.max;                         // end of gauge

  const normalize = (raw) =>
    (Number(raw) - min) / (max - min || 1);

  // Normalized segments
  const lowOrangeMin = normalize(lo.min);
  const lowOrangeMax = normalize(lo.max);

  const greenMin = normalize(green.min);
  const greenMax = normalize(green.max);

  const highOrangeMin = normalize(ho.min);
  const highOrangeMax = normalize(ho.max);

  // Normalize measured value
  const valNorm = normalize(value);
  const arrowNorm = Math.min(1, Math.max(0, valNorm));

  const outOfRange =
    Number(value) < green.min || Number(value) > green.max;

  return (
    <Box position="relative" width="100%" >
      {/* Gauge colored bar */}
      <Box
        height={5}
        borderRadius={0}
        sx={{
          background: `linear-gradient(
            to right,
            ${theme.palette.traffic.orange} ${lowOrangeMin * 100}%,
            ${theme.palette.traffic.orange} ${lowOrangeMax * 100}%,
            ${theme.palette.traffic.green} ${greenMin * 100}%,
            ${theme.palette.traffic.green} ${greenMax * 100}%,
            ${theme.palette.traffic.orange} ${highOrangeMin * 100}%,
            ${theme.palette.traffic.orange} ${highOrangeMax * 100}%
          )`
        }}
      />

      {/* Arrow indicator with tooltip */}
      <Box
        position="absolute"
        top={-20}
        left={`calc(${arrowNorm * 100}% - 8px)`}
        sx={{ transition: "left 0.3s ease-out"}}
      >
        <Tooltip title={`${value} ${reference.unit}`}>
          <ChevronDown
            size={22}
            strokeWidth={3}
            color= {arrowColor}
          />
        </Tooltip>
      </Box>
    </Box>
  );
}
